// @ts-check
// =============================================================================
// js/app/quickplay-mode.js — is this page load in quickplay mode?
//
// A leaf module (no imports) so ANYTHING can ask — session.js needs the answer
// inside its login timing, and importing the full quickplay.js from there
// would cycle (quickplay → deck-list → session). The mode itself lives in
// app/quickplay.js; this file only answers the question.
// =============================================================================

/**
 * Is the client running in quickplay mode? True on deckbiter.cards/quickplay
 * (trailing slash tolerated). The path is the whole switch — no query params,
 * no config. Matches the FINAL path segment so the dev instance's /dev prefix
 * (deploy.yml: dev is served at /dev) flips the mode too.
 * @returns {boolean}
 */
export function isQuickplay() {
	return /(^|\/)quickplay\/?$/.test(window.location.pathname);
}
